import React from 'react'
import { Box, IconButton, Stack, useMediaQuery } from '@chakra-ui/react';
import {FaEnvelope,FaPhoneSquareAlt} from 'react-icons/fa'


const Social = () => {
  const [notSmallScreen] = useMediaQuery("(min-width: 600px)");
  return (
    <Stack>
          
          
    </Stack>
  )
}

export default Social